import React from 'react';
import { Link } from 'react-router-dom'; // Important for routing
import { Helmet } from 'react-helmet';

const bookingData = [
  {
    id: 1,
    imgSrc: '/images/ourfleet/8.jpg',
    title: 'Swift Dzire',
    description:
      'Ideal for city rides and short trips, Swift Dzire by Mauli Cabs ensures a comfortable, efficient, and budget-friendly travel experience.',
  },
  {
    id: 2,
    imgSrc: '/images/ourfleet/6.jpg',
    title: 'Aura',
    description:
      'With stylish looks and smooth performance, Aura from Mauli Cabs is perfect for both city rides and weekend escapes.',
  },
  {
    id: 3,
    imgSrc: '/images/ourfleet/7.jpg',
    title: 'Toyota Etion',
    description:
      'Mauli Cabs presents the Toyota Etios — your reliable ride for daily commutes, family outings, and those spontaneous weekend getaways.',
  },
  {
    id: 4,
    imgSrc: '/images/ourfleet/4.jpg',
    title: 'Ertiga',
    description:
      'Spacious and reliable, Ertiga by Mauli Cabs is ideal for family outings and longer road trips.',
  },
  {
    id: 5,
    imgSrc: '/images/ourfleet/3.jpg',
    title: 'Innova Crysta',
    description:
      'Experience luxury and comfort with Innova Crysta — perfect for business trips, tours, and special occasions.',
  },
  {
    id: 6,
    imgSrc: '/images/ourfleet/1.jpg',
    title: 'Kia Carens',
    description:
      'Travel in style with Kia Carens — a blend of comfort, space, and premium features.',
  },
  {
    id: 7,
    imgSrc: '/images/ourfleet/2.jpg',
    title: 'Innova Cab',
    description:
      'Mauli Cabs Innova offers comfort and safety, ideal for long-distance journeys.',
  },
  {
    id: 9,
    imgSrc: '/images/keyword/145.avif',
    title: 'Fortuner ',
    description:
      'Where luxury meets adventure — Fortuner.',
  },
  {
    id: 8,
    imgSrc: '/images/ourfleet/9.jpg',
    title: 'Tempo Traveller',
    description:
      'Mauli Cabs Tempo Traveller provides spacious seating, perfect for group outings and tours.',
  },
  
  {
    id: 9,
    imgSrc: '/images/keyword/62.jpg',
    title: 'Urbania ',
    description:
      'Ride in style with Urbania — comfort meets class.',
  },
  {
    id: 9,
    imgSrc: '/images/ourfleet/10.webp',
    title: 'Mini Bus',
    description:
      'Smart space. Smooth ride. That’s our Mini Bus.',
  },
  {
    id: 9,
    imgSrc: '/images/ourfleet/10.jpg',
    title: 'Luxury Bus',
    description:
      'Ride with elegance in our Luxury Bus — plush interiors, AC, and full comfort.',
  },
 
 
];

const Ourfleet = () => {

  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Our Fleet - Mauli Cabs",
    "url": "https://www.maulicabs.com/our-fleets",  // Replace with actual URL
    "description": "Discover the range of vehicles offered by Mauli Cabs for travel from Mumbai to Pune. Our fleet includes Innova Crysta, Ertiga, and comfortable sedans for one-way and round trips."
  };

  
  return (
    <>


      
  <Helmet>
    <title>Our Fleet | Mauli Cabs | Innova Crysta, Ertiga & Sedan Taxis</title>
    <meta
      name="description"
      content="Explore Mauli Cabs' well-maintained fleet including Innova Crysta, Ertiga, and sedans for safe and comfortable travel between Mumbai and Pune. Choose your ideal cab today."
    />
    <meta
      name="keywords"
      content="mauli cabs fleet, innova crysta taxi mumbai to pune, ertiga cab service, sedan cab pune mumbai, mauli cab vehicle options, cab models mauli cabs, pune to mumbai vehicle types, comfort cab service mumbai pune, taxi fleet mauli cabs, mauli cabs cars"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>

      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title" >
                  Our Fleets
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vs-tour-package style-2 space pt-3">
        <div className="container">
          <div className="row g-4">
            {bookingData.map((item) => (
              <div className="col-md-6 col-xl-4" key={item.id}>
                <div className="ourfleet-card">
                  <div className="ourfleet-thumb">
                    <img src={item.imgSrc} alt={item.title} className="w-100" />
                  </div>
                  <div className="ourfleet-content">
                    <h5 className="ourfleet-title">{item.title}</h5>
                    <p className="ourfleet-desc">{item.description}</p>
                    <Link to="/booking" className="ourfleet-btn">
                      Book Now
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Ourfleet;
